import {
    PointerSensor,
    closestCenter,
    useSensor,
    useSensors,
    type DragEndEvent,
    type DragStartEvent,
    type UniqueIdentifier,
} from '@dnd-kit/core';

export interface UseSortableTableDndParams {
    onDragStart?: () => void;
    onReorder: (activeId: UniqueIdentifier, overId: UniqueIdentifier) => void;
}

const useSortableTableDnd = ({ onDragStart, onReorder }: UseSortableTableDndParams) => {
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: { distance: 8 },
        }),
    );

    const handleDragStart = (_event: DragStartEvent) => {
        onDragStart?.();
    };

    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;
        onReorder(active.id, over.id);
    };

    return {
        sensors,
        collisionDetection: closestCenter,
        handleDragStart,
        handleDragEnd,
    };
};

export default useSortableTableDnd;
